import { render, staticRenderFns } from "./ChatBotSettings.vue?vue&type=template&id=3791bc92&scoped=true&"
import script from "./ChatBotSettings.vue?vue&type=script&lang=js&"
export * from "./ChatBotSettings.vue?vue&type=script&lang=js&"
import style0 from "./ChatBotSettings.vue?vue&type=style&index=0&id=3791bc92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3791bc92",
  null
  
)

export default component.exports